import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-warm-900 border-t border-warm-800 py-8 px-4" data-id="element-18">
        <div className="max-w-6xl mx-auto" data-id="element-19">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-20">
            <p className="text-warm-100/60 text-sm" data-id="element-21">
              © {new Date().getFullYear()} El Método Cena y Cama. Todos los
              derechos reservados.
            </p>
            <div className="flex items-center gap-6" data-id="element-22">
              <button onClick={() => setShowPrivacy(true)} className="text-warm-100/60 hover:text-gold text-sm transition-colors" data-id="element-23">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="text-warm-100/60 hover:text-gold text-sm transition-colors" data-id="element-24">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {showPrivacy && <Modal onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-25">
          <div className="space-y-4 text-warm-800" data-id="element-26">
            <p data-id="element-27">
              En El Método Cena y Cama, nos comprometemos a proteger tu
              privacidad y la seguridad de tus datos personales.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-28">
              Información que Recopilamos
            </h3>
            <p data-id="element-29">
              Recopilamos información que nos proporcionas directamente al
              realizar una compra, incluyendo tu nombre, dirección de correo
              electrónico y datos de pago procesados de forma segura a través de
              nuestros proveedores de pago.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-30">
              Uso de la Información
            </h3>
            <p data-id="element-31">Utilizamos tu información para:</p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-32">
              <li data-id="element-33">Procesar y entregar tu compra del Método Cena y Cama</li>
              <li data-id="element-34">
                Enviarte actualizaciones y contenido relacionado con el producto
              </li>
              <li data-id="element-35">Mejorar nuestros servicios y experiencia del cliente</li>
              <li data-id="element-36">Cumplir con obligaciones legales</li>
            </ul>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-37">Protección de Datos</h3>
            <p data-id="element-38">
              Implementamos medidas de seguridad técnicas y organizativas
              apropiadas para proteger tus datos personales contra acceso no
              autorizado, alteración, divulgación o destrucción.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-39">Tus Derechos</h3>
            <p data-id="element-40">
              Tienes derecho a acceder, rectificar, eliminar o limitar el uso de
              tus datos personales. Para ejercer estos derechos, contáctanos a
              través de nuestro correo electrónico de soporte.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-41">Cookies</h3>
            <p data-id="element-42">
              Utilizamos cookies esenciales para el funcionamiento del sitio
              web. No utilizamos cookies de seguimiento de terceros sin tu
              consentimiento explícito.
            </p>

            <p className="text-sm text-warm-800/60 mt-6" data-id="element-43">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
            </p>
          </div>
        </Modal>}

      {/* Terms and Conditions Modal */}
      {showTerms && <Modal onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-44">
          <div className="space-y-4 text-warm-800" data-id="element-45">
            <p data-id="element-46">
              Bienvenido a El Método Cena y Cama. Al acceder y utilizar este
              sitio web y adquirir nuestros productos digitales, aceptas los
              siguientes términos y condiciones.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-47">Producto Digital</h3>
            <p data-id="element-48">
              El Método Cena y Cama es un producto digital que incluye guías,
              matrices y protocolos en formato PDF. El acceso es inmediato tras
              la confirmación del pago.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-49">Licencia de Uso</h3>
            <p data-id="element-50">
              Al adquirir el producto, obtienes una licencia personal, no
              transferible, para uso privado. No está permitido:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-51">
              <li data-id="element-52">Compartir, revender o redistribuir el contenido</li>
              <li data-id="element-53">Reproducir o copiar el material para uso comercial</li>
              <li data-id="element-54">Modificar o crear obras derivadas sin autorización</li>
            </ul>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-55">
              Política de Reembolso
            </h3>
            <p data-id="element-56">
              Debido a la naturaleza digital del producto y el acceso inmediato,
              no ofrecemos reembolsos una vez que el contenido ha sido
              entregado. Te recomendamos revisar toda la información del
              producto antes de realizar tu compra.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-57">
              Descargo de Responsabilidad
            </h3>
            <p data-id="element-58">
              El Método Cena y Cama proporciona información y estrategias
              educativas. Los resultados pueden variar según cada familia y
              situación. No sustituye el consejo médico o psicológico
              profesional. Consulta con un profesional de la salud si tienes
              preocupaciones sobre el desarrollo o bienestar de tu hijo.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-59">
              Propiedad Intelectual
            </h3>
            <p data-id="element-60">
              Todo el contenido, incluyendo textos, gráficos, logos y diseños,
              está protegido por derechos de autor y es propiedad exclusiva de
              El Método Cena y Cama.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-61">Modificaciones</h3>
            <p data-id="element-62">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación en el sitio web.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-63">Ley Aplicable</h3>
            <p data-id="element-64">
              Estos términos se rigen por las leyes aplicables en tu
              jurisdicción. Cualquier disputa será resuelta en los tribunales
              competentes.
            </p>

            <p className="text-sm text-warm-800/60 mt-6" data-id="element-65">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
            </p>
          </div>
        </Modal>}
    </>;
}
interface ModalProps {
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
function Modal({
  onClose,
  title,
  children
}: ModalProps) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-66">
      {/* Backdrop */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onClick={onClose} className="absolute inset-0 bg-warm-900/80 backdrop-blur-sm" data-id="element-67" />

      {/* Modal */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} className="relative bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-68">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-warm-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-69">
          <h2 className="text-2xl font-bold font-heading text-warm-900" data-id="element-70">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-warm-50 rounded-full transition-colors text-warm-800" data-id="element-71">
            <XIcon className="w-5 h-5" data-id="element-72" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-73">
          {children}
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-white border-t border-warm-100 px-6 py-4" data-id="element-74">
          <button onClick={onClose} className="w-full bg-gold text-warm-900 font-bold py-3 px-6 rounded-xl hover:bg-gold-dark transition-colors" data-id="element-75">
            Cerrar
          </button>
        </div>
      </motion.div>
    </div>;
}